module.exports = __webpack_public_path__ + "static/media/textananalytics_active.15dbbefb.svg";